import styled from 'styled-components';

export const StyledSearchInput = styled.form`
  margin: 20px auto 0;
  position: relative;

  & > * {
    font-size: ${({ theme }) => theme.fontSizes.xxl};
  }

  & *:active {
    outline: 0;
  }

  & *:focus {
    outline: 0;
  }

  .control-button {
    border: none;
    padding: 0;
    background-color: transparent;
    color: ${({ theme }) => theme.colors.tycoonMain};
    display: inline-block;
    width: 1em;
    height: 1em;
    cursor: pointer;
    position: absolute;
    top: .3em;

    &__search {
      left: 0;
    }

    &__reset {
      display: ${({ value }) => value ? 'inline-block' : 'none'};
      right: 0;
    }
  }

  .search-input {
    display: block;
    box-sizing: border-box;
    background-color: transparent;
    width: 100%;
    padding: .2em 1.2em;
    border: none;
    border-bottom: 2px solid ${({ theme }) => theme.colors.gray};
  }
`;